'use client';

import { __assign } from '../../_virtual/_tslib.js';
import { createContext } from 'react';
import { initialCascaderState, initialCascaderProps } from './index.js';
import { ACTIONS } from './actions.js';
import { deepCloneObject } from '../../TreeSelect/helpers.js';
import { removeParentId, setTemporaryValue } from './childReducer/selectReducer.js';
import { VIEWINDEX } from '../constants.js';
import { setSingleTemporaryValue } from './childReducer/selectSingleReducer.js';

var cascaderReducer = function (state, action) {
    var type = action.type;
    switch (type) {
        case ACTIONS.SHOW: {
            // clone from value to temporaryValue (Refresh)
            return __assign(__assign({}, state), { isShow: true, temporaryValue: state.value });
        }
        case ACTIONS.HIDE: {
            return __assign(__assign({}, state), { isShow: false });
        }
        case ACTIONS.TOGGLE: {
            return __assign(__assign({}, state), { isShow: action.payload });
        }
        case ACTIONS.SET_KEYWORD: {
            return __assign(__assign({}, state), { keyword: action.payload });
        }
        case ACTIONS.APPLY_CALLBACK: {
            typeof action.payload === 'function' && action.payload(state.temporaryValue);
            return state;
        }
        case ACTIONS.SYNC_TEMPORARY_TO_VALUE: {
            return __assign(__assign({}, state), { value: state.temporaryValue });
        }
        case ACTIONS.SET_SELECT_PARENT_ID: {
            var parentId = action.payload;
            var viewIndex = parentId !== -1 ? VIEWINDEX.RIGHT : VIEWINDEX.LEFT;
            return __assign(__assign({}, state), { parentId: parentId, viewIndex: viewIndex });
        }
        case ACTIONS.MOBILE_SET_SELECT_PARENT_ID: {
            var _a = action.payload, parentId = _a.parentId, leftScrollPosition = _a.leftScrollPosition;
            var viewIndex = parentId !== -1 ? VIEWINDEX.RIGHT : VIEWINDEX.LEFT;
            return __assign(__assign({}, state), { parentId: parentId, viewIndex: viewIndex, scrollPosition: __assign(__assign({}, state.scrollPosition), { left: leftScrollPosition }) });
        }
        case ACTIONS.REMOVE_SELECTED_OR_HOVER: {
            return __assign(__assign({}, state), { isHover: false, hoverParentId: -1, parentId: -1 });
        }
        case ACTIONS.SET_HOVER: {
            return __assign(__assign({}, state), { isHover: action.payload });
        }
        case ACTIONS.SET_HOVER_ID: {
            return __assign(__assign({}, state), { hoverParentId: action.payload, isHover: true });
        }
        case ACTIONS.SET_MOUSE_LEAVE: {
            return __assign(__assign({}, state), { hoverParentId: -1, isHover: false });
        }
        case ACTIONS.SET_TEMPORARY_VALUE: {
            var clonedState = deepCloneObject(state);
            return setTemporaryValue(clonedState, action);
        }
        case ACTIONS.SET_SINGLE_TEMPORARY_VALUE: {
            var clonedState = deepCloneObject(state);
            return setSingleTemporaryValue(clonedState, action);
        }
        case ACTIONS.REMOVE_ALL_TEMPORARY_VALUE: {
            return __assign(__assign({}, state), { temporaryValue: [] });
        }
        case ACTIONS.ON_CANCEL: {
            // Reset temporaryValue and close drop down
            return __assign(__assign({}, state), { isShow: false, temporaryValue: state.value, keyword: '', parentId: -1, hoverParentId: -1 });
        }
        case ACTIONS.ON_CONFIRM: {
            // Copy temporaryValue to value
            return __assign(__assign({}, state), { isShow: false, value: state.temporaryValue, keyword: '', parentId: -1, hoverParentId: -1 });
        }
        case ACTIONS.SET_VALUE_FROM_PROP: {
            var newValue = action.payload;
            return __assign(__assign({}, state), { isShow: false, value: newValue, temporaryValue: newValue });
        }
        case ACTIONS.REMOVE_PARENT_ID: {
            var clonedState = deepCloneObject(state);
            // Modify directly value and temporaryValue
            return removeParentId(clonedState, action.payload);
        }
        case ACTIONS.ON_DROPDOWN_ITEM_FOCUS: {
            return __assign(__assign({}, state), { hoverParentId: action.payload, isHover: true, viewIndex: VIEWINDEX.LEFT });
        }
        case ACTIONS.SET_SEARCH_RESULT: {
            return __assign(__assign({}, state), { searchResult: action.payload });
        }
        default:
            console.error('Unknown type of Reducer');
            return __assign({}, state);
    }
};
var CascaderContext = createContext({
    state: initialCascaderState,
    props: initialCascaderProps,
    t: function (_) { return ''; },
    dispatch: function () { }
});

export { CascaderContext, cascaderReducer };
//# sourceMappingURL=reducer.js.map
